<template lang="pug">
span
  .md-layout
    .md-layout-item.ml-auto
      md-button.md-warning(
        style='float: right;'
        @click='createTemplate()')
        v-icon(style='color: black !important; padding-right: 4px;') mdi-plus
        span(style='color: black')
          | {{$t('templates.create')}}
  DataProvider(:endpoint='endpoint', :filter='filter', ref='dataProvider' :key="componentKey")
    div(slot-scope='{ data: response, error, loading }')
      DataTable(
        ref='dataTable'
        :title="$t('templates.templates')"
        :customTotal='(response && response.total) || 0'
        :selectable='false'
        @pagination='handlePagination'
        v-if='response && response.data'
        :data='response && response.data'
        :loading='loading'
        customHeader
        :endpoint='endpoint'
        :filter='filter'
        :labels='labels'
        :currentSort.sync='filter.orderBy',
        :currentSortOrder.sync='filter.order',
        :formatLabelFunction='formatLabels'
        :createHeader='createHeaderPDF'
        fileName="templates"
      )#dataTable
        template(slot="custom-filter" )
          v-text-field(
            style='float: right; width: 350px; margin-top: 15px; margin-right: 5px;'
            :placeholder="$t('simplifiedEditing.searchLabel')",
            hide-details
            height="46px"
            filled
            dense
            background-color='#F9F9F9'
            :value='searchQuery'
            @input='handleSearch'
          ).search-input
        template(slot='cells'  slot-scope='{ item }')
          md-table-cell(:md-label='labels[0]') {{formatLabels(item, 0)}}
            md-tooltip(md-direction="bottom")
              | {{ formatLabels(item, 7) }}
          md-table-cell(:md-label='labels[1]') {{formatLabels(item, 1)}}
          md-table-cell(:md-label='labels[2]') {{formatLabels(item, 2)}}
          md-table-cell(:md-label='labels[3]' md-sort-by="createdAt" ) {{formatLabels(item, 3)}}
          md-table-cell(:md-label='labels[4]') {{formatLabels(item, 4)}}
          md-table-cell(:md-label='labels[5]' md-sort-by="updatedAt") {{formatLabels(item, 5)}}
          md-table-cell(:md-label='labels[6]') {{formatLabels(item, 6)}}
          md-table-cell(:md-label="$t('templates.actions')")
            v-row(no-gutters style='justify-content: flex-end; gap: 8px; flex-wrap: nowrap;')
              v-col(cols='auto')
                v-btn(
                  x-small
                  fab
                  depressed
                  color="#FF9800"
                  @click='openNotificationDialog(item)'
                  :disabled='isEditDisabledBasedOnStatusAndChannel(item, "APPROVED")'
                )
                  v-icon(color="white")
                    | domain_verification
                md-tooltip(md-direction="bottom")
                  | {{$t('templates.sendNotification')}}
              v-col(cols='auto')
                v-btn(
                  x-small
                  fab
                  dark
                  depressed
                  color="#20A6E5"
                  @click='openDialog(true, item, "view")'
                )
                  v-icon(dark )
                    | visibility
                md-tooltip(md-direction="bottom")
                  | {{$t('templates.viewTemplate')}}
              v-col(cols='auto')
                v-btn(
                  x-small
                  fab
                  depressed
                  color="#4caf50"
                  @click='openDialog(false, item, "edit")'
                  :disabled='isEditDisabledBasedOnStatusAndChannel(item, "DRAFT")'
                )
                  v-icon(color="white")
                    | create
                md-tooltip(md-direction="bottom")
                  | {{$t('templates.editTemplate')}}
              v-col(cols='auto')
                v-btn(
                  x-small
                  fab
                  dark
                  depressed
                  color="#5A42BC"
                  @click='duplicateTemplate(item)'
                )
                  v-icon(dark style="fill: none")
                    | file_copy
                md-tooltip(md-direction="bottom")
                  | {{$t('templates.duplicateTemplate')}}
              v-col(cols='auto')
                v-btn(
                  @click='deleteTemplate(item._id)'
                  x-small
                  fab
                  depressed
                  color="#f44336"
                  :disabled='!item.canDelete'
                )
                  v-icon(color="white" )
                    | delete
                md-tooltip(md-direction="bottom")
                  | {{$t('templates.deleteTemplate')}}
        template(slot='footer' slot-scope='{ pagination }')
          v-row(style='justify-content: flex-end;')
            v-col(cols='auto')
              md-field
                label(for='pages') {{ $t('assistantsList.perPage') }}
                md-select(v-model='pagination.perPage' name='pages' )
                  md-option(
                    v-for='item in pagination.perPageOptions',
                    :key='item',
                    :label='item',
                    :value='item')
                    | {{ item }}
  template(v-if="dialog")
    TemplateEditDialog(
      :dialog.sync='dialog'
      :editDisabled='editDisabled'
      @close='closeDialog'
      @rerender='forceRerender'
      :itemId='itemId'
      :method='method'
      :key='item._id'
    )
  template(v-if="notificationDialog")
    TemplateSendNotification(
      :notificationDialog.sync='notificationDialog'
      :channelSettings="channelSettings"
      @closeNotification='closeNotificationDialog'
      :itemId='itemId'
      :key="`${item._id}-notification`"
    )

</template>

<script>
import Pagination from '@/components/Pagination.vue'
import Swal from 'sweetalert2'
import DataProvider from '@/components/DataProvider'
import DataTable from '@/components/DataTable.vue'
import TemplateEditDialog from '@/components/TemplateEditDialog'
import { selectedLocale } from '@/plugins/i18n'
import moment from 'moment'
import { mapFields } from 'vuex-map-fields'
import TemplateSendNotification from '@/components/TemplateSendNotification.vue'
import debounce from 'lodash.debounce'

export default {
  components: {
    TemplateSendNotification,
    Pagination,
    DataTable,
    TemplateEditDialog,
    DataProvider
  },
  data () {
    return {
      labels: [this.$t('templates.status'), this.$t('templates.template'), this.$t('commonWords.channel'),
        this.$t('templates.createdIn'), this.$t('templates.createdBy'), this.$t('templates.updated'), this.$t('templates.updatedBy')],
      componentKey: 0,
      editDisabled: false,
      dialog: false,
      itemId: null,
      notificationDialog: false,
      item: {
        channels: [],
        messageOptions: {
          text: [],
          options: {
            'quick_replies': []
          }
        },
        type: '',
        subtype: '',
        name: ''
      },
      method: '',
      filter: {
        page: 0,
        perPage: 5,
        orderBy: 'createdAt',
        order: 'desc'
      },
      channelSettings: null,
      searchQuery: ''
    }
  },
  computed: {
    endpoint () {
      return `${process.env.VUE_APP_BACKEND_BASE_URL}/message-templates`
    },
    ...mapFields('selectedAssistant', ['assistantId'])
  },
  async created () {
    await this.getChannelConfig()
  },
  methods: {
    forceRerender () {
      this.componentKey += 1
    },
    incrementCopyName (name) {
      const copyTag = '(copy'
      if (!name.includes(copyTag)) {
        return `${name} ${copyTag})`
      }
      const copyIndex = name.lastIndexOf(copyTag)
      const baseName = name.slice(0, copyIndex)
      const remainingPart = name.slice(copyIndex)

      if (remainingPart === '(copy)') {
        return `${baseName}(copy 2)`
      } else {
        const parts = remainingPart.slice(copyTag.length).trim().split(' ')
        const versionNumber = parseInt(parts[0], 10)

        if (isNaN(versionNumber)) {
          return `${baseName}(copy 2)`
        } else {
          const newVersionNumber = versionNumber + 1
          return `${baseName}(copy ${newVersionNumber})`
        }
      }
    },
    returnActiveChannel (channelsArr) {
      return channelsArr.find(channel => channel.isActive)
    },
    async duplicateTemplate (item) {
      try {
        const template = item
        const templateName = this.incrementCopyName(template.name)
        const channel = this.returnActiveChannel(template.channels)

        const newTemplate = {
          name: templateName,
          channels: [
            {
              ...channel,
              status: channel.name === 'whatsapp' ? 'DRAFT' : 'APPROVED'
            }
          ],
          messageOptions: {
            text: [
              template?.messageOptions?.text[0] ?? ''
            ],
            options: {
              'quick_replies': template?.messageOptions?.options?.quick_replies ?? []
            }
          },
          type: 'NOTIFICATION',
          'subtype': 'DEFAULT'
        }
        await this.$axios.post('/message-templates', {
          ...newTemplate,
          duplicate: true
        })
        this.forceRerender()
      } catch (e) {
        Swal.fire({
          icon: 'error',
          title: this.$t('templates.errorDuplicate')
        })
      }
    },
    handleSearch: debounce(function (searchText) {
      if (searchText) {
        this.$set(this.filter, 'search', searchText)
        this.searchQuery = searchText
      } else {
        this.$delete(this.filter, 'search')
      }
    }, 300),
    async getChannelConfig () {
      try {
        const request = await this.$axios.get('/assistant-configs/channels')
        this.channelSettings = request?.data
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: this.$t('testNotificationDialog.thereWasAnErrorInYourRequest')
        })
      }
    },
    handlePagination (pagination) {
      const newFilter = {}
      const { currentPage, perPage } = pagination
      if (currentPage && this.filter.page !== currentPage - 1) {
        newFilter.page = currentPage - 1
      }
      if (perPage && this.filter.perPage !== perPage) {
        newFilter.perPage = perPage
      }
      Object.assign(this.filter, newFilter)
    },
    openDialog (editable, item, method) {
      this.method = method
      this.itemId = item?._id
      this.editDisabled = editable
      this.dialog = true
    },
    closeDialog () {
      this.clearItem()
      this.dialog = false
    },
    openNotificationDialog (item) {
      this.itemId = item?._id
      this.notificationDialog = true
    },
    closeNotificationDialog () {
      this.clearItem()
      this.notificationDialog = false
    },
    clearItem () {
      this.item = {
        channels: [],
        messageOptions: {
          text: [],
          options: {
            'quick_replies': []
          }
        },
        type: '',
        subtype: '',
        name: ''
      }
    },
    createTemplate () {
      this.method = 'create'
      this.editDisabled = false
      this.dialog = true
    },
    async deleteTemplate (templateId) {
      // TODO delete template
      Swal.fire({
        icon: 'warning',
        title: this.$t('templates.areYouSure'),
        text: this.$t('templates.youWillNotBeAble'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: this.$t('templates.cancel'),
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: this.$t('templates.yesDelete'),
        buttonsStyling: false
      }).then((result) => {
        if (result.value) {
          this.$axios.delete(`/message-templates/${templateId}`)
            .then(() => {
              Swal.fire({
                title: this.$t('templates.deleted'),
                text: `${this.$t('templates.youDeleted')} ${templateId}`,
                type: 'success',
                icon: 'success',
                showConfirmButton: false,
                timer: 1500
              })
              setTimeout(() => this.forceRerender(), 2000)
              this.$vuetify.goTo(0)
            })
            .catch(error => {
              Swal.fire({
                icon: 'error',
                title: this.$t('templates.error'),
                html: `${this.$t('templates.couldNotDelete')} ${error}`
              })
            })
        }
      })
    },
    formatDate (date) {
      return moment(date).locale(selectedLocale).format('L LT')
    },
    isEditDisabledBasedOnStatusAndChannel (item, status) {
      const whatsappChannel = item.channels.find(channel => channel.name === 'whatsapp')
      if (whatsappChannel && whatsappChannel.status) {
        return whatsappChannel.status !== status
      }
      return false
    },
    formatLabels (item, i) {
      const isChannelWhatsapp = item.channels.find(channel => channel.name === 'whatsapp')
      const channelTooltipTranslation = {
        APPROVED: this.$t('templates.templateApproved'),
        DRAFT: this.$t('templates.saveAsDraft'),
        REJECTED: this.$t('templates.templateRejected')
      }
      switch (i) {
        case 0:
          if (isChannelWhatsapp && isChannelWhatsapp.isActive) {
            const statusToLowerCase = isChannelWhatsapp.status.toLowerCase()
            return ['approved', 'draft', 'rejected'].includes(statusToLowerCase) ? this.$t(`templates.${statusToLowerCase}`) : this.$t('templates.inactive')
          } else {
            return this.$t('templates.active')
          }
        case 1:
          return item.name
        case 2:
          return item.channels.filter(item => item.isActive).map(item => {
            const firstLetter = item.name.charAt(0).toUpperCase()
            const remainingLetters = item.name.slice(1)
            return firstLetter + remainingLetters
          }).join(', ')
        case 3:
          return this.formatDate(item.createdAt)
        case 4:
          return item.createdBy.name
        case 5:
          return this.formatDate(item.updatedAt)
        case 6:
          return item.updatedBy.name
        case 7:
          if (isChannelWhatsapp && isChannelWhatsapp.isActive) {
            return ['APPROVED', 'DRAFT', 'REJECTED'].includes(isChannelWhatsapp.status) ? channelTooltipTranslation[isChannelWhatsapp.status] : this.$t('templates.templatePending')
          } else {
            return channelTooltipTranslation.APPROVED
          }
        default:
          break
      }
    },
    createHeaderPDF (doc, total) {
      doc.setFontSize(14)
      doc.setFont(undefined, undefined, '700')
      doc.text(15, 10, 'Templates')

      doc.setFontSize(10)
      doc.setFont('times', undefined, '700')

      doc.setFont('times', undefined, '700')
      doc.text(15, 22, 'Total: ')
      doc.setFont(undefined, undefined, '300')
      doc.text(25, 22, `${total}`)

      const tableOffsetY = 30
      return tableOffsetY
    }
  }
}
</script>

<style lang="scss" scoped>
#dataTable {
  &::v-deep .md-table-head:last-child {
    width: 213px !important;
  }
}

</style>
